import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { PiggyBank, TrendingUp, Bitcoin, Building2 } from 'lucide-react';
export function BankLieSection() {
  return <section className="py-24 bg-navy-950 relative" data-id="element-18">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-19">
        <FadeIn className="text-center mb-16" data-id="element-20">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-21">
            Ahorrar en el banco es{' '}
            <span className="text-red-400/80 italic" data-id="element-22">perder lentamente.</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-23">
            El banco usa tu dinero para invertir en Wall Street y a ti te paga
            el 0.01%. Te están usando para hacerse ricos.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-16 items-stretch" data-id="element-24">
          {/* The Lie */}
          <FadeIn delay={0.1} direction="right" className="bg-navy-900 border border-navy-700 p-10 rounded-2xl flex flex-col items-center text-center relative overflow-hidden group" data-id="element-25">
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-navy-950/50" data-id="element-26"></div>
            <PiggyBank className="w-20 h-20 text-gray-600 mb-6 group-hover:scale-95 transition-transform" strokeWidth={1} data-id="element-27" />
            <h3 className="text-2xl font-bold mb-4 text-gray-300" data-id="element-28">
              El Sistema Viejo
            </h3>
            <div className="text-5xl font-serif text-gray-500 mb-4" data-id="element-29">0.01%</div>
            <p className="text-gray-400 relative z-10" data-id="element-30">
              Tu dinero se estanca. La inflación devora tu poder adquisitivo año
              tras año.
            </p>
          </FadeIn>

          {/* The Truth */}
          <FadeIn delay={0.2} direction="left" className="bg-navy-800 border border-gold-500/30 p-10 rounded-2xl flex flex-col items-center text-center relative overflow-hidden group shadow-[0_0_40px_rgba(212,175,55,0.05)]" data-id="element-31">
            <div className="absolute inset-0 bg-gradient-to-b from-gold-500/5 to-transparent" data-id="element-32"></div>

            <div className="flex gap-4 mb-6 relative z-10" data-id="element-33">
              <div className="w-12 h-12 rounded-full bg-gold-500/10 flex items-center justify-center border border-gold-500/20" data-id="element-34">
                <TrendingUp className="w-6 h-6 text-gold-400" data-id="element-35" />
              </div>
              <div className="w-12 h-12 rounded-full bg-gold-500/10 flex items-center justify-center border border-gold-500/20" data-id="element-36">
                <Bitcoin className="w-6 h-6 text-gold-400" data-id="element-37" />
              </div>
              <div className="w-12 h-12 rounded-full bg-gold-500/10 flex items-center justify-center border border-gold-500/20" data-id="element-38">
                <Building2 className="w-6 h-6 text-gold-400" data-id="element-39" />
              </div>
            </div>

            <h3 className="text-2xl font-bold mb-4 text-gold-300" data-id="element-40">El Código</h3>
            <div className="text-3xl font-serif text-white mb-4 italic" data-id="element-41">
              Activos Reales
            </div>
            <p className="text-gray-300 relative z-10" data-id="element-42">
              Rompe el ciclo. Aprende a poner tus dólares donde los bancos ponen
              los suyos: En activos reales, en Bitcoin y en deuda inteligente.
              El sistema no es justo, pero ahora tienes el mapa para vencerlo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}